import React from 'react';
import styles from './Badge.module.scss';
import { BadgeProps } from './Badge.type';
const text = {
  approved: 'Approved',
  rejected: 'Rejected',
  'on-review': 'On Review',
  draft: 'Draft',
  uncovered: 'Uncovered'
};
const Badge: React.FC<BadgeProps> = ({ type = 'approved' }) => {
  return (
    <div
      data-testid="badge"
      className={styles['Container'] + ' ' + styles[type]}
    >
      <p>{text[type]}</p>
    </div>
  );
};

export default Badge;
